// extracted by mini-css-extract-plugin
export default {"container":"header_container__skYEA"};